import { Link } from 'react-router'
import logoPlq from '#app/assets/logo-plq.png'

export function Logo() {
	return (
		<Link
			to="/"
			aria-label="Accueil — Parti libéral du Québec"
			className="focus-visible:ring-ring inline-flex items-center rounded-md outline-hidden focus-visible:ring-2 focus-visible:ring-offset-2"
		>
			<img src={logoPlq} alt="" className="h-12 w-auto" />
		</Link>
	)
}
